export enum CorreiosCode {
  SEDEX_REVERSO = 'SEDEX_REVERSO',
  SEDEX_CONTRATO = 'SEDEX_CONTRATO',
  PAC_REVERSO = 'PAC_REVERSO',
  PAC_CONTRATO = 'PAC_CONTRATO',
  DESVIO_MINI = 'DESVIO_MINI',
  ENTREGA_LOCAL = 'ENTREGA_LOCAL',
}
